var map = {
	"./Si-Co.svg": "c2b7",
	"./Si-barrier-Model.svg": "a851",
	"./Si-n-Model.svg": "e16a",
	"./Si-plunger-Model.svg": "762a",
	"./SiGe-barrier.svg": "797f",
	"./SiGe-n.svg": "ff5f",
	"./SiGe-plunger.svg": "d7db"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d6ef";